module.exports = __webpack_public_path__ + "static/media/ccNewLogo2.be073280.png";